import { render, staticRenderFns } from "./PersonTile.vue?vue&type=template&id=332c300a&scoped=true"
import script from "./PersonTile.vue?vue&type=script&lang=js"
export * from "./PersonTile.vue?vue&type=script&lang=js"
import style0 from "./PersonTile.vue?vue&type=style&index=0&id=332c300a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332c300a",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PersonTile.vue
// module id = 211
// module chunks = 0